module.exports = __webpack_public_path__ + "static/avatar-1469cc00de3a299d4af836ba38d4cdf6.jpg";